module.exports = __webpack_public_path__ + "img/sld_acdb_t1_b1.f2edb5e2.svg";